export default __webpack_public_path__ + "proximanova-black-webfont.woff2";